import { useEffect } from "react";


export default function AdminRouteMeta({ children }) {
  useEffect(() => {
    const existing = document.head.querySelector('meta[name="robots"][data-admin-route="cc"]');
    const meta = existing || document.createElement("meta");
    meta.setAttribute("name", "robots");
    meta.setAttribute("content", "noindex, nofollow, noarchive");
    meta.setAttribute("data-admin-route", "cc");
    if (!existing) document.head.appendChild(meta);

    return () => meta.remove();
  }, []);

  return children;
}
